import { FocusTrapUtils, onClick } from "@nx-paeonia/utils-events";
import { andThen, ok } from "@nx-paeonia/utils-result";
import { signal } from "@nx-paeonia/utils-signals";
import { withCssUnit } from "./helpers/common.helper.js";
import {
	animateMenuClose,
	animateMenuOpen,
	animateSubmenuClose,
	animateSubmenuOpen,
	getHeightOfMenu,
	MobileMenuProperties,
	setVariableOnMobileMenu,
} from "./helpers/mobile-menu.helpers.js";

const isOpen = signal<boolean>(false);
// @ts-expect-error - if this does not work the rest of the script can be ignored as well.
const focusTrap = FocusTrapUtils.createSidebarTrap(document.querySelector<HTMLElement>("#mobile-menu"));

isOpen.subscribe((isOpen: boolean): void => {
	if (isOpen) {
		// Recalculate the height quickly.
		_mobileMenuInit();
		focusTrap.activate();
		animateMenuOpen();
	} else {
		// unblock scroll
		animateMenuClose();
		focusTrap.deactivate();
	}
});

function _mobileMenuInit() {
	const headerHeightResult = getHeightOfMenu();

	andThen(headerHeightResult, (val) => {
		setVariableOnMobileMenu(MobileMenuProperties.offsetTop, withCssUnit(val, "px"));

		return ok(val);
	});
}

function _mobileMenuEventInit() {
	onClick("[aria-controls='mobile-menu']", () => {
		isOpen.update((curr) => !curr);
	});

	onClick(
		".mobile-menu-main-item button",
		(_, element) => {
			if (element.getAttribute("aria-expanded") === "true") {
				animateSubmenuClose(element);
			} else {
				animateSubmenuOpen(element);
			}
		},
		{ preventDefault: true },
	);
}

_mobileMenuInit();
_mobileMenuEventInit();
